exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#authPanel[data-v-8a1b0caa]{max-width:506px;margin:20vh auto 0}#authPanel .card-body[data-v-8a1b0caa]{padding:37px 63px}", ""]);

// exports
